module.exports = __webpack_public_path__ + "static/img/M-7.e4cf93f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/myixuekao/M-7.png
// module id = MQln
// module chunks = 0